import React from 'react';
import { Box, Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';

interface Person {
  id: string;
  name: string;
}

interface LinkedPeopleChipsProps {
  people: Person[];
}

export const LinkedPeopleChips: React.FC<LinkedPeopleChipsProps> = ({ people }) => {
  const navigate = useNavigate();

  if (people.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
      {people.map((person) => (
        <Chip
          key={person.id}
          icon={<PersonIcon />}
          label={person.name}
          onClick={() => navigate(`/people?search=${encodeURIComponent(person.name)}`)}
          color="primary"
          variant="filled"
          clickable
          size="small"
        />
      ))}
    </Box>
  );
};

export default LinkedPeopleChips;
